import { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './category.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Category } from "model/product/category.model";

export interface CategoryDetailsProps extends DetailsStateAndDispatchProps<Category>,
  RouteComponentProps, StateProps, DispatchProps {
}

const CategoryDetails: FC<CategoryDetailsProps> = (props: any) => {
  return (
    <DetailsPage<Category>
      title='会员详情'
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Category>
        column={2}
        columns={props.columns}
        dataSource={props.entity}
      >
      </ProDescriptions>
    </DetailsPage>);
};

const mapStateToProps = ({ category }: RootState) => ({
  entity: category.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(CategoryDetails);
